import React from 'react';
import type { FunctionComponent } from 'react';
import { differenceInDaysHandler, longDateHandler } from '@utils';

interface DeletedStatusProps {
	deletedOnUtc: string;
}

export const DeletedStatus: FunctionComponent<DeletedStatusProps> = ({ deletedOnUtc }) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bold">Deleted on:</p>
			<p className="account-status-content-row">{longDateHandler(deletedOnUtc)}</p>
			<p className="account-status-content-row">{differenceInDaysHandler(deletedOnUtc)} days ago</p>
		</div>
	);
};
